import { NumberStepInput, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

type QuantityStepperProps = {
  productType: string;
  updateProductQuantity: (value: number) => void;
};

const QuantityStepper = ({ productType, updateProductQuantity }: QuantityStepperProps) => {
  const { t } = useTranslation('webshop.business.quantityStepper');

  const handleQuantityChange = (value: number) => {
    updateProductQuantity(value);
  };

  return (
    <div>
      <Typography variant='h5' component='p' mb={200}>
        {productType ? t('productType', { productType: productType.toLowerCase() }) : t('default')}
      </Typography>
      <NumberStepInput
        name='quantity'
        size='small'
        min={1}
        defaultValue={1}
        onChange={handleQuantityChange}
      />
    </div>
  );
};

export default QuantityStepper;
